import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import OrderList from '../components/OrderList/OrderList'
import Pagination from '../components/Resources/Pagination/Pagination'
import { Auth, UserInfo } from '../contexts/allContext'
import { useRequest } from '../hooks/useRequest'

const OrderListPage = () => {
    const { stateUser } = useContext(UserInfo)
    const userInfo = stateUser.info
    const { stateAuth } = useContext(Auth)
    const token = stateAuth?.token
    const { handleFetch } = useRequest()
    const location = useLocation()
    const navigate = useNavigate()

    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(true)
    const [totalResults, setTotalResults] = useState(0)

    const [loading1, setLoading1] = useState(true)
    const [orderNumber, setOrderNumber] = useState('')
    const [orderProducts, setOrderProducts] = useState([])
    const [updateProductStatus, setUpdateProductStatus] = useState([])
    const [statusToggle, setStatusToggle] = useState(false)

    const queryParams = new URLSearchParams(location.search)
    const pageFromUrl = parseInt(queryParams.get('page')) || 1
    const [page, setPage] = useState(pageFromUrl - 1)
    const itemsPerPage = 10

    // ---------------------
    const [selectedDates, setSelectedDates] = useState({ startDate: '', endDate: '' })
    const handleDateChange = (dates) => {
        setSelectedDates(dates)
    }

    const [search, setSearch] = useState({
        value: '',
        searchBy: 'order_number',
        isSearchAble: false,
    })

    const [filters, setFilters] = useState({
        all: true,
        sortBy: 'desc',
        delivery: '',
        order: '',
        payment: '',
        showAll: true,
    })

    const fetchProducts = async (currentPage) => {
        setLoading(true)
        const skip = currentPage * itemsPerPage
        const { value: searchValue, searchBy } = search
        const { sortBy, delivery, order, payment, showAll } = filters
        const params = {
            skip,
            limit: itemsPerPage,
            is_custom_order: false,
            sort_order_by: sortBy,
            delivery_status: delivery,
            payment_status: payment,
            order_status: order,
            start_date: selectedDates.startDate,
            end_date: selectedDates.endDate,
            ...(searchValue && { [searchBy]: searchValue }),
        }
        try {
            const { data, isSuccess } = await handleFetch('v2/orders/', params, token)
            if (isSuccess) {
                setProducts(data)
                setTotalResults(data[0].results)
            }
        } catch (err) {
            console.log(err)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (userInfo?.id) {
            fetchProducts(page)
        }
    }, [userInfo?.id, page, statusToggle, filters, selectedDates.endDate])

    useEffect(() => {
        if (search.isSearchAble) {
            fetchProducts(page)
        }
    }, [search])

    // make sure search product shows on first page ...
    useEffect(() => {
        if (filters?.search) {
            setPage(0)
        }
    }, [filters])

    //update url
    useEffect(() => {
        const newPageNumber = page + 1
        const newQueryParams = new URLSearchParams(location.search)
        newQueryParams.set('page', newPageNumber)
        navigate(`?${newQueryParams.toString()}`, { replace: true })
    }, [page, navigate, location.search])

    const fetchOrderProducts = async () => {
        setLoading1(true)
        try {
            const { data, isSuccess } = await handleFetch(`v2/orders/single/${orderNumber}`, token)
            if (isSuccess) {
                setOrderProducts(data)
            }
        } catch (err) {
            console.log(err)
        } finally {
            setLoading1(false)
        }
    }

    useEffect(() => {
        if (orderNumber) {
            fetchOrderProducts()
        }
    }, [orderNumber])

    return (
        <>
            <OrderList
                products={products}
                loading={loading}
                totalResults={totalResults}
                setOrderNumber={setOrderNumber}
                orderProducts={orderProducts}
                loading1={loading1}
                setUpdateProductStatus={setUpdateProductStatus}
                updateProductStatus={updateProductStatus}
                setStatusToggle={setStatusToggle}
                statusToggle={statusToggle}
                search={search}
                setSearch={setSearch}
                filters={filters}
                setFilters={setFilters}
                setPage={setPage}
                handleDateChange={handleDateChange}
            />
            <Pagination
                totalResults={totalResults}
                itemsPerPage={itemsPerPage}
                onPageChange={setPage}
                currentPage={page}
            />
        </>
    )
}

export default OrderListPage
